import { IOffer } from '../repositories/search-offers.legacy/v2/types/offer';

export const getOfferServices = (offer: IOffer) => {
  const { isTop3, isPremium, isStandard, isAuction } = offer;

  return { isTop3, isPremium, isStandard, isAuction };
};
